import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import sanityClient from "../../sanityClient";
import Footer from "../homepage/component/footer";
import { PortableText } from "@portabletext/react";
import Navbar from "../../components/navbar";

const BlogDetail = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "post" && slug.current == $slug][0]{
          title,
          publishedAt,
          body,
         categories[]->{
      title
    },
    readTime,
    author->{
      name
    },
          mainImage {
            asset-> {
              url
            }
          }
        }`,
        { slug }
      )
      .then((data) => {
        setPost(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching blog post:", error);
        setLoading(false);
      });
  }, [slug]);

  if (loading) return <p>Loading...</p>;
  if (!post) return <p>Post not found.</p>;

  return (
    <div>
      <Navbar />
      <div className="px-4 py-16 lg:mx-[140px] md:mx-16 sm:mx-8">
        <h1 className="text-lg  md:text-2xl lg:text-3xl font-bold mb-4">{post.title}</h1>
        <p className="text-sm text-gray-500 mb-4">
          {post.publishedAt && new Date(post.publishedAt).toDateString()} •{" "}
          {post.readTime || "5 min read"}
        </p>
        {post.mainImage && (
          <img
            src={post.mainImage.asset.url}
            alt={post.title}
            className="w-full max-h-[400px] object-cover rounded mb-8"
          />
        )}
        <div className="prose  mx-auto">
          {post.categories?.length > 0 && (
            <div className="mb-6 flex flex-wrap gap-2">
              {post.categories.map((cat, idx) => (
                <span
                  key={idx}
                  className="bg-orange-100 text-orange-700 text-sm px-3 py-1 rounded-full"
                >
                  {cat.title}
                </span>
              ))}
            </div>
          )}

          <div className="prose text-sm md:text-base  text-gray-800 text-justify font-light">
            <PortableText value={post.body} />
          </div>

          <p className="text-sm text-gray-600 mt-2">
            {post.author?.name && <>By {post.author.name}</>}
          </p>

          <p className="text-sm text-gray-500 mt-8 md:mt-16 text-center">
            {post.publishedAt && (
              <>Published: {new Date(post.publishedAt).toDateString()} </>
            )}
            • {post.readTime || "5 min read"}
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default BlogDetail;
